import { render, staticRenderFns } from "./BlueLink.vue?vue&type=template&id=861ed2ea&scoped=true&"
import script from "./BlueLink.vue?vue&type=script&lang=ts&"
export * from "./BlueLink.vue?vue&type=script&lang=ts&"
import style0 from "./BlueLink.vue?vue&type=style&index=0&id=861ed2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861ed2ea",
  null
  
)

export default component.exports